import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { getAvailableCategories } from "../constants";

export const CategorySelector: React.FC = () => {
  const availableCategories = getAvailableCategories();

  const formatCategoryName = (category: string): string => {
    return (
      category.charAt(0).toUpperCase() + category.slice(1).replace(/-/g, " ")
    );
  };

  const getDescription = (category: string): string => {
    return `${category.replace(/-/g, " ")} related terms and definitions`;
  };

  return (
    <div className="flex flex-col gap-12">
      <div className="text-center">
        <h1 className="text-[#2F1612] text-4xl md:text-6xl font-medium mb-6 font-[AeonikPro] leading-tight">
          Artisan glossary
        </h1>
        <p className="text-[#464646] text-lg md:text-xl max-w-3xl mx-auto font-[Inter] leading-relaxed">
          Explore comprehensive glossaries for different artisan categories.
          Find definitions and explanations for industry-specific terms.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {availableCategories.map((category) => (
          <RouterLink
            key={category}
            to={`/glossary/${category}/a`}
            className="group"
          >
            <div className="relative bg-white p-8 border border-[#E5E7EB] hover:border-[#ED6E5C] transition-all duration-300 ease-in-out h-full overflow-hidden cursor-pointer">
              <div className="flex flex-col h-full">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-6 h-6 bg-[#FFF1EF] rounded-md flex items-center justify-center group-hover:bg-[#ED6E5C] transition-colors duration-300">
                    <div className="w-3 h-3 bg-[#ED6E5C] rounded group-hover:bg-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-[#2F1612] text-xl md:text-2xl font-medium font-[AeonikPro] leading-tight group-hover:text-[#153243] transition-colors duration-300">
                    {formatCategoryName(category)}
                  </h3>
                </div>

                <p className="text-[#646D72] text-base leading-relaxed font-[Inter] mb-4 flex-1">
                  A to Z of {getDescription(category)}
                </p>

                <div className="flex items-center text-[#ED6E5C] text-base font-medium group-hover:text-[#D85D4A] transition-colors duration-300">
                  <span className="mr-3">Browse terms</span>
                  <FaArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform duration-300" />
                </div>
              </div>
            </div>
          </RouterLink>
        ))}
      </div>
    </div>
  );
};
